import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { AdminPromotionRow, AdminPromotionDetail, AdminPaged } from '@repo/shared-types';
import type { CreatePromotionInput, UpdatePromotionInput } from '@repo/validation';
import { adminFetchApi } from '../lib/api';
import type { AdminListParams } from './useAdminOrgs';

export function usePromotions(p: AdminListParams) {
  const qs = new URLSearchParams({ page: String(p.page), limit: String(p.limit), sort: p.sort });
  if (p.q) qs.set('q', p.q);
  return useQuery({
    queryKey: ['admin', 'promotions', p],
    queryFn: () => adminFetchApi<AdminPaged<AdminPromotionRow>>(`/admin/promotions?${qs}`),
  });
}

export function usePromotion(id: string | undefined) {
  return useQuery({
    queryKey: ['admin', 'promotions', id],
    queryFn: () => adminFetchApi<AdminPromotionDetail>(`/admin/promotions/${id}`),
    enabled: !!id,
  });
}

export function useCreatePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreatePromotionInput) =>
      adminFetchApi<AdminPromotionRow>('/admin/promotions', { method: 'POST', body: JSON.stringify(body) }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin', 'promotions'] });
      toast.success('Đã tạo ưu đãi');
    },
    onError: (e: Error) => toast.error(e.message),
  });
}

export function useUpdatePromotion(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdatePromotionInput) =>
      adminFetchApi<AdminPromotionRow>(`/admin/promotions/${id}`, { method: 'PATCH', body: JSON.stringify(body) }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['admin', 'promotions'] });
      toast.success('Đã cập nhật ưu đãi');
    },
    onError: (e: Error) => toast.error(e.message),
  });
}
